/* eslint-disable import/prefer-default-export */

export const ActiveTools = {
	SMOOTH: 'Smooth',
	MOVE_GPS: 'MoveGPS'
};
